import React, { Component } from "react";
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import MomentLocaleUtils, { formatDate, parseDate } from 'react-day-picker/moment';
import 'moment/locale/es';
import ReactTooltip from "react-tooltip";

var fechaInput = undefined;
export default class CampoFecha extends Component {

  constructor(props) {
    super(props);
    this.state = {
      name: props.name,
      size: props.size,
      title: props.title,
      hidden: props.hidden,
      editable: props.editable,
      type: props.type,
      label: props.label,
      minValue: props.minValue,
      maxValue: props.maxValue,
      minLength: props.minLength,
      maxLenght: props.maxLenght,
      required: props.required,
      nullable: props.nullable,
      debitable: props.debitable,
      format: props.format,
      date: ""
    }
  };
  componentDidMount() {

  }


  handleChange = (e) => {
    var fecha=formatDate(e, 'DD/MM/YYYY')
    this.props.inputValue(fecha, this.state.name, false, "","DATE");
  };

  render() {
    const FORMAT = 'DD/MM/yyyy';
    //var fecha = this.props.value
    return (
      <div>
        <label className="input-label" data-tip={this.props.title} >
            <i className="fas fa-question-circle" style={{fontSize:"25px",color:"#9c9c9c"}}></i> {this.props.label}
        </label>
        <div className="input-group mb-3">
          <DayPickerInput
            ref={(a) => (this.dateSelect = a)}
            formatDate={formatDate}
            parseDate={parseDate}
            format={FORMAT}
            placeholder={FORMAT}
            //value={fecha}
            dayPickerProps={{
              locale: 'es',
              localeUtils: MomentLocaleUtils,
            }}
            inputProps={{
              //readonly: 'readonly',
              className: "input-box form-control form-fecha",
              required: this.state.required
            }}
            onDayChange={(selectedDay) => { 
              fechaInput = selectedDay
              if(selectedDay!==undefined){
                this.handleChange(selectedDay) 
              }
            }}
            onDayPickerHide={() => {
              if(fechaInput===undefined){
                ///// borrar contenido campo fecha
                this.dateSelect.input.defaultValue = ""
                this.dateSelect.input.value = ""
                this.dateSelect.state.value = ""
                this.dateSelect.state.typedValue = ""
              }
              
            }}

          />
          <div className="input-group-append">
            <span className="input-group-text input-box"><i className="far fa-calendar-alt"></i></span>
          </div>
        </div>
        <ReactTooltip/>
      </div>
    );
  }
}

